var _g, _use, _use2, _use3, _use4, _use5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 400,
    viewBox: "0 0 300 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-207.387 -311.331)scale(.89332)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 572.362,
    r: 160,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 10.03299999,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 572.362,
    r: 145,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000037",
      strokeWidth: 10.03299999,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M392.327 496.48c-8.272-82.935 24.083-82.938 15.288 0",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 8.95532227,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-31 -64.5)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "rotate(20 230.025 691.537)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "rotate(40 325.532 646.348)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "rotate(60 358.702 630.653)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "rotate(80 376.35 622.303)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "rotate(100 387.87 616.852)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "rotate(120 396.42 612.807)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "rotate(140 403.39 609.509)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "rotate(160 409.52 606.608)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "matrix(-1 0 0 -1 830.56 1207.766)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "rotate(200 421.04 601.158)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "rotate(220 427.17 598.258)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "rotate(240 434.14 594.96)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "rotate(260 442.69 590.914)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "rotate(-80 454.21 585.464)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "rotate(-60 471.859 577.113)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "rotate(-40 505.028 561.419)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "rotate(-20 600.536 516.23)"
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 572.362,
    r: 84.474,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000037",
      strokeWidth: 10.23999977,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 572.362,
    r: 72.315,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 12,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(-.177 .088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.332 554.245c-3.146-9.94-29.568-32.568-1.223-34.015 29.37 1.6.872 23.529-1.718 34.178",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 23.10970306,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 555.191v-25.657",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#b93c3c",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 527.834,
    r: 4.819,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m404.688 557.487 6.565-16.11",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#b93c3c",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    transform: "matrix(-1 0 0 1 799.938 0)"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 572.362,
    r: 16.035,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#b93c3c",
      strokeWidth: 6.66957808,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 572.362,
    r: 8.537,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    id: "d",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    transform: "rotate(-72 399.973 572.358)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    id: "e",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    transform: "rotate(-72 399.973 572.358)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    id: "f",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    transform: "rotate(-72 399.973 572.358)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    width: "100%",
    height: "100%",
    transform: "rotate(-72 399.973 572.358)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin1);
export default __webpack_public_path__ + "static/media/Pin1.c909f50385c24fd1aa53d8e15f1a7286.svg";
export { ForwardRef as ReactComponent };